'use client';
import { ProductCardImage } from './ProductCardImage';
import { Box } from '../Box';
import Link from 'next/link';
import { IProductCardContext, ProductCardContext } from './ProductCardContext';
import { getRoute } from '@/src/packages/utils/routes';
import { paths } from '@/src/packages/routes';
import { pathParams } from '@/src/packages/routes/pathParams.enum';
import { IFetchProductVariantGridSchema } from '@bitmap/contracts';
import { ProductCardSwatches } from '@/src/packages/components/ui/ProductCard/ProductCardSwatches';
import { ProductFormContext } from '@/src/packages/components/contexts/product-form.context';
import { ProductCardContainer } from '@/src/packages/components/ui/ProductCard/ProductCardContainer';
import { ProductCardFooter } from '@/src/packages/components/ui/ProductCard/ProductCardFooter';
import { useState } from 'react';

export const ProductCard = ({
  productVariant,
}: {
  productVariant: IFetchProductVariantGridSchema;
}) => {
  const [isHovered, setHovered] = useState<boolean>(false);

  const ctx: IProductCardContext = {
    productVariant,
    isHovered,
    currency: { iso: 'GBP', conversionRate: 1 },
  };

  return (
    <ProductFormContext
      options={productVariant.product.options}
      skus={productVariant.skus}
    >
      <ProductCardContext value={ctx}>
        <Link
          href={getRoute({
            route: paths.PRODUCTS_SINGLE,
            params: { [pathParams.PRODUCT_SINGLE]: productVariant.slug },
          })}
          className="block"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <ProductCardContainer>
            <Box className="relative">
              <Box className="absolute left-4 top-4 z-[1] border bg-white px-1.5 pb-[4px] pt-[4px] text-[10px] uppercase leading-none">
                New
              </Box>
              <ProductCardImage />
              <Box className="absolute bottom-6 left-1/2 hidden -translate-x-1/2 items-center text-center lg:flex">
                <ProductCardSwatches productVariant={productVariant} />
              </Box>
            </Box>
            <ProductCardFooter />
          </ProductCardContainer>
        </Link>
      </ProductCardContext>
    </ProductFormContext>
  );
};
